import React from 'react';
import PropTypes from 'prop-types';

const ChatIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14.001">
        <g fill="none">
            <path d="M0 7.375V4a4 4 0 014-4h6a4 4 0 014 4v3.375a4 4 0 01-4 4H3.842L0 14z" />
            <path d="M1.2 11.726l1.965-1.345.327-.224.397.015.112.002H10c1.544 0 2.8-1.256 2.8-2.8V4c0-1.544-1.256-2.8-2.8-2.8H4A2.803 2.803 0 001.2 4v7.725M0 14.002V4a4 4 0 014-4h6a4 4 0 014 4v3.375a4 4 0 01-4 4H4c-.052 0-.105-.002-.158-.004L0 14.001z" fill={fill} />
        </g>
    </svg>
);

ChatIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

ChatIcon.defaultProps = {
    width: '14',
    height: '14.001',
    fill: '#4b254e'
};

export default ChatIcon;
